import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-2b5f36c5"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "item-container"
};
var _hoisted_2 = ["id"];
var _hoisted_3 = {
  class: "content"
};
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "left"
  }, null, -1);
});
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "right"
  }, null, -1);
});
var _hoisted_6 = ["innerHTML"];
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "bottom"
  }, null, -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("h2", {
    class: "title",
    id: _ctx.title
  }, _toDisplayString(_ctx.title), 9, _hoisted_2), _createElementVNode("div", _hoisted_3, [_hoisted_4, _hoisted_5, _createElementVNode("div", {
    class: "desc",
    innerHTML: _ctx.desc
  }, null, 8, _hoisted_6), _hoisted_7])]);
}